// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__34llq","head":"Table_head__3ZNbX","col":"Table_col__1DC36"};